




export enum EEvaluationStatus {
    Okay = 1,
    NotOkay = 0,
    Uknown = 2
};

export interface IEvaluationStatics {
    okay: number;
    notOkay: number;
    uknown: number
};


export interface IEvaluations {
    [key: string]: {
        status?: EEvaluationStatus,
        okay?: number;
        notOkay?: number
    }
};

export const emptyEvaluationStatics = {
    okay: 0,
    notOkay: 0,
    uknown: 0
}